export default {
  type: "object",
  properties: {
    id: {
      type: "integer",
      description: "unique identifier",
      example: "1"
    },
    name: {
      type: "string",
      description: "non-localized unique description",
      example: "EU"
    },
    label: {
      type: "integer",
      description: "size marking",
      example: "32"
    },
    sub_label: {
      type: "string|null",
      description: "size submarking",
      example: null
    }
  }
};
